import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Users, Globe, Lock, ArrowLeft, Crown, DollarSign } from 'lucide-react';

const API_URL = import.meta.env.VITE_API_URL || 'https://emailai-backend-658e.onrender.com/api';
const getToken = () => localStorage.getItem('accessToken') || localStorage.getItem('token');

export default function CommunityJoin() {
  const { communityId } = useParams();
  const navigate = useNavigate();
  const [community, setCommunity] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    setIsLoggedIn(!!getToken());
    fetchCommunity();
  }, []);

  const fetchCommunity = async () => {
    try {
      const token = getToken();
      const headers: any = token ? { Authorization: `Bearer ${token}` } : {};
      const res = await fetch(`${API_URL}/community/${communityId}`, { headers });
      if (res.status === 401) { setIsLoggedIn(false); setLoading(false); return; }
      const data = await res.json();
      if (data.success) setCommunity(data.data?.community || data.community);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const handleJoin = async () => {
    if (!isLoggedIn) { navigate(`/signin?redirect=/community/join/${communityId}`); return; }
    const token = getToken();
    await fetch(`${API_URL}/community/${communityId}/join`, {
      method: 'POST', headers: { Authorization: `Bearer ${token}` }
    });
    navigate(`/community/${communityId}`);
  };

  if (loading) return <div style={{ textAlign: 'center', padding: '100px', color: '#6b7280' }}>Loading...</div>;
  if (!community) return <div style={{ textAlign: 'center', padding: '100px' }}><h2>Community not found</h2></div>;

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', padding: '40px 20px', fontFamily: 'system-ui, sans-serif' }}>
      <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', color: '#6b7280', marginBottom: '24px', fontSize: '14px' }}>
        <ArrowLeft size={18} /> Back
      </button>

      <div style={{ background: 'linear-gradient(135deg, #8b5cf6, #6366f1)', padding: '40px', borderRadius: '20px', color: 'white', textAlign: 'center', marginBottom: '24px' }}>
        <div style={{ width: '80px', height: '80px', borderRadius: '20px', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '36px', margin: '0 auto 16px' }}>
          {community.name?.charAt(0)}
        </div>
        <h1 style={{ fontSize: '28px', marginBottom: '8px' }}>{community.name}</h1>
        <p style={{ opacity: 0.9, fontSize: '14px', marginBottom: '16px' }}>{community.description || 'Join this amazing community!'}</p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', fontSize: '14px' }}>
          <span><Users size={16} style={{ marginRight: '6px', verticalAlign: 'middle' }} />{community.memberCount || 0} members</span>
          <span>{community.visibility === 'private' ? <Lock size={16} style={{ marginRight: '6px', verticalAlign: 'middle' }} /> : <Globe size={16} style={{ marginRight: '6px', verticalAlign: 'middle' }} />}{community.visibility === 'private' ? 'Private' : 'Public'}</span>
        </div>
      </div>

      <div style={{ textAlign: 'center', padding: '30px', background: 'white', borderRadius: '16px', border: '1px solid #e5e7eb' }}>
        {community.isMonetized && community.subscriptionPrice > 0 ? (
          <>
            <div style={{ fontSize: '48px', fontWeight: 'bold', color: '#7c3aed', marginBottom: '4px' }}>
              ${(community.subscriptionPrice / 100).toFixed(0)}
            </div>
            <div style={{ color: '#6b7280', marginBottom: '20px' }}>per month</div>
          </>
        ) : (
          <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#16a34a', marginBottom: '20px' }}>
            🆓 Free Community
          </div>
        )}
        <button onClick={handleJoin} style={{ padding: '14px 40px', background: '#7c3aed', color: 'white', border: 'none', borderRadius: '12px', cursor: 'pointer', fontWeight: 'bold', fontSize: '16px' }}>
          {isLoggedIn ? (community.isMonetized ? 'Join & Subscribe' : 'Join Community') : 'Sign In to Join'}
        </button>
        {!isLoggedIn && <p style={{ fontSize: '13px', color: '#9ca3af', marginTop: '12px' }}>You'll be redirected to sign in first</p>}
      </div>
    </div>
  );
}